export default "__VITE_ASSET__DwEScMmD__"